// JsFromRoutes CacheKey 3d6ba945075e6d051170b11a95c51ff5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_pages/search'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_pages/typeahead_select'),
  liveTypeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_pages/live_typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_pages'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_pages'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/landing_pages/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/landing_pages/:id'),
}
